import _ from 'lodash';

import createEnum from 'scripts/lib/create_enum';
import createModel, { prop } from './lib/create_model';

export const PaymentStatusEventType = createEnum('COMPLETED', 'DECLINED', 'SUBMITTED', 'TIMED_OUT', 'CARD_VIEWED');

export default createModel({
  modelName: 'PaymentStatusEventContent',

  properties: {
    eventType: prop().oneOf(..._.keys(PaymentStatusEventType)).isRequired,
    secureDataItemId: prop(String).isRequired,
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/payment_status_event_content.js